import { connect } from 'react-redux'
import Assessment from './assessment'
import { getFetchRequest } from '../../../../stores/works/works.selectors'
import { fetchAssessmentFileWorks } from '../../../../stores/works/works.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  const fetchRequest = getFetchRequest(state)
  return {
    id: match.params.assessmentFileId,
    pending: fetchRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: id => dispatch(fetchAssessmentFileWorks(id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Assessment)
